import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";

const DataPrivacy = () => {
  return (
    <div className="mt-4">
      <Link to="/main/profile">
        <div className="flex items-center gap-4 font-bold text-purple-800 hover:text-purple-500">
          <MdArrowBack className="flex h-4 w-4" />
          <p>Back to Settings</p>
        </div>
      </Link>
      <div className="mt-4">
        <div className="align-start flex flex-col rounded-lg bg-gradient-to-b from-gray-50 to-purple-50 p-2 p-4 text-left shadow-md">
          <h4>Download Data</h4>
          <div className="w-full pb-4">
            <div className="align-start mt-6 flex w-full justify-start gap-10">
              <div className="w-full max-w-[400px]">
                <p className="w-full font-medium text-gray-800">
                  Account and analytics data
                </p>
              </div>
              <button className="flex font-bold text-purple-800 hover:text-purple-500">
                Export in CSV Format
              </button>
            </div>
          </div>
        </div>

        <div className="align-start mt-4 flex flex-col rounded-lg bg-gradient-to-b from-gray-50 to-purple-50 p-2 p-4 text-left shadow-md">
          <h4>Download Data</h4>
          <div className="text-lg mt-4 font-medium text-gray-900">Delete Account</div>
          <div className="w-full pb-4">
            <p className="mt-2 text-sm text-gray-800">
              Permanently Delete the account and associated data.
            </p>
            <div className="mt-4">
              <button className="rounded-full border-2 border-purple-800 px-4 py-2 font-bold text-purple-800 transition duration-150 ease-in-out hover:bg-purple-50 hover:text-purple-500">
                Delete Account
              </button>
            </div>
          </div>
        </div>

        <div className="align-start mt-4 flex flex-col rounded-lg bg-gradient-to-b from-gray-50 to-purple-50 p-2 p-4 text-left shadow-md">
          <h4>Privacy Settings</h4>
          <div className="w-full pb-4">
            <div className="align-start mt-6 flex w-full justify-start gap-10">
              <div className="w-full max-w-[400px]">
                <p className="w-full font-medium text-gray-800">Data Sharing</p>
                <p className="mt-2 text-sm text-gray-800">
                  Manage the data collected or shared with third-party services.
                </p>
              </div>
              <button className="flex font-bold text-purple-800 hover:text-purple-500">
                Manage
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataPrivacy;
